// extracted by mini-css-extract-plugin
export default {"fullScreenContainer":"liveGame_fullScreenContainer__UXURf"};